export const SUPPORTS_OBJECT_PROTOTYPE_IS_PROTOTYPE_OF = "isPrototypeOf" in Object.prototype;
